import qs from 'qs'

export const queryMenu = () => {
  const query = qs.stringify(
    {
      populate: {
        exhibition_pages: {
          populate: {
            titles: true,
            slugs: true
          }
        },
        page_entries: {
          populate: {
            titles: true,
            slugs: true
          }
        },
        secondary_page_entries: {
          populate: {
            titles: true,
            slugs: true
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `menu?${query}`
}
